import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DrawerState {
  isDrawerOpen: boolean;
}

export const initialDrawerState: DrawerState = {
  isDrawerOpen: false,
};

/**
 * The redux reducer used for drawer state management.
 */
const drawerSlice = createSlice({
  name: 'DRAWER',
  initialState: initialDrawerState,
  reducers: {
    setIsDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isDrawerOpen = action.payload;
    },
  },
});

export const { setIsDrawerOpen } = drawerSlice.actions;

export default drawerSlice.reducer;
